import * as actionTypes from "../constants/actionTypes";
import createReducer from "../lib/createReducer";
import * as config from "../config";

const defaultState = {  
    registrationMethod: localStorage.getItem(config.storageKeys.registrationMethod) ? localStorage.getItem(config.storageKeys.registrationMethod) : "",
};

function REGISTRATION_METHOD_STORE(state, action) {
    const { registrationMethod } = action;
    return {
        ...state,
        registrationMethod,
    }   
}

function REGISTRATION_METHOD_CLEAR(state, action) {
	return defaultState;
}

const handlers = {};
handlers[actionTypes.REGISTRATION_METHOD_STORE] = REGISTRATION_METHOD_STORE;
handlers[actionTypes.REGISTRATION_METHOD_CLEAR] = REGISTRATION_METHOD_CLEAR;
export default createReducer(defaultState, handlers);